<template>
  <div :class="['metric-bar', { 'metric-bar--compact': compact }]">
    <p v-if="label && !compact" class="metric-bar__label">{{ label }}</p>
    <div class="metric-bar__track-wrap">
      <div class="metric-bar__track">
        <div class="metric-bar__avg">
          <span v-if="!compact" class="metric-bar__avg-lbl">avg</span>
        </div>
        <div
          v-for="(dot, i) in validDots" :key="i"
          class="metric-bar__dot"
          :style="{ left: zToPercent(dot.z) + '%', background: dot.color || dotColor(dot.z) }"
          :title="dot.label || (dot.z !== null ? String(dot.z) : null)"
        />
      </div>
    </div>
    <div v-if="!compact" class="metric-bar__ends">
      <span>below</span><span>above</span>
    </div>
  </div>
</template>

<script>
import { VIVASCORE_COLORS, zToPercent } from '@/utils/vivascore'

export default {
  name: 'MetricBar',

  props: {
    // Always an array: single-dot passes [{z}], multi-dot history passes [{z, label}, ...]
    // All dots render at the same size regardless of variant.
    // TODO: consider whether most-recent dot should be visually distinguished in multi-dot mode
    dots: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    validDots() {
      return this.dots.filter(d => d.z !== null && d.z !== undefined)
    },
  },

  methods: {
    zToPercent,
    dotColor(z) {
      return z >= 0 ? VIVASCORE_COLORS.above : VIVASCORE_COLORS.below
    },
  },
}
</script>

<style scoped>
.metric-bar__label {
  font-size: 11px;
  color: #6A6660;
  margin-bottom: 6px;
}

.metric-bar__track-wrap {
  position: relative;
  height: 22px;
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.metric-bar__track {
  width: 100%;
  height: 2px;
  background: #E0DCD3;
  border-radius: 1px;
  position: relative;
}

.metric-bar__avg {
  position: absolute;
  left: 50%;
  top: -5px;
  width: 1px;
  height: 12px;
  background: #C4C0B4;
  transform: translateX(-50%);
}

.metric-bar__avg-lbl {
  position: absolute;
  left: 50%;
  top: -17px;
  transform: translateX(-50%);
  font-size: 8px;
  color: #B8B4AA;
  white-space: nowrap;
}

.metric-bar__dot {
  position: absolute;
  top: -5px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  transform: translateX(-50%);
}

.metric-bar__ends {
  display: flex;
  justify-content: space-between;
}

.metric-bar__ends span {
  font-size: 9px;
  color: #D0CCC4;
}

/* Compact variant: smaller track, no label or below/above text */
.metric-bar--compact .metric-bar__track-wrap {
  height: 16px;
}

.metric-bar--compact .metric-bar__dot {
  width: 9px;
  height: 9px;
  top: -4px;
}
</style>
